export default function UsersPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-foreground mb-4">User Management</h1>
      <p className="text-muted-foreground">
        User administration and access control will be displayed here.
      </p>
    </div>
  );
}
